import { ObservationTypeUrlTags } from 'src/app/model/enum/observation-type-url-tags.enum';
import { LazyLoadedStatesManager } from '../class/lazy-loaded-states-manager.class';
import { generateUrlWordMatch } from '../helpers/lazy-loaded-states.helpers';
import { LazyLoadedStates } from '../interfaces/lazy-loaded-states.interface';

export const PrintLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    customFormBuilder: LazyLoadedStates,
    customFormBuilderPreview: LazyLoadedStates,
    observation: LazyLoadedStates,
    walkthrough: LazyLoadedStates,
    anecdotal: LazyLoadedStates,
    rubric: LazyLoadedStates,
    formal: LazyLoadedStates,
    differentiated: LazyLoadedStates,
    customForm: LazyLoadedStates,
    slo: LazyLoadedStates,
    principalSlo: LazyLoadedStates,
    spm_iep_pg: LazyLoadedStates,
    ntp: LazyLoadedStates,
    ratingform: LazyLoadedStates
}>({
    base: {
        name: 'authenticated.print',
        url: '/print',
        abstract: true
    },
    customFormBuilder: {
        name: 'authenticated.print.customFormBuilder',
        url: '/custom-form-builder',
        abstract: true
    },
    customFormBuilderPreview: {
        name: 'authenticated.print.customFormBuilder.preview',
        url: '/preview/:formId',
        params: {
            formId: {
                raw: true,
                type: 'string'
            }
        }
    },
    observation: {
        name: 'authenticated.print.observation',
        url: '/observation/:userId/:observationId',
        abstract: true,
        params: {
            userId: {
                raw: true,
                type: 'string'
            },
            observationId: {
                raw: true,
                type: 'string'
            },
            observationUrlTag: {
                raw: true,
                type: 'string'
            }
        }
    },
    walkthrough: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.Walkthrough}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.Walkthrough)}}`,
    },
    anecdotal: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.Anecdotal}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.Anecdotal)}}`,
    },
    rubric: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.Rubric}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.Rubric)}}`,
    },
    formal: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.Formal}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.Formal)}}`,
    },
    differentiated: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.Differentiated}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.Differentiated)}}`,
    },
    customForm: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.CustomForm}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.CustomForm)}}`,
    },
    slo: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.SLO}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.SLO)}}`,
    },
    principalSlo: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.PrincipalSLO}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.PrincipalSLO)}}`,
    },
    spm_iep_pg: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.SPM_IEP_PG}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.SPM_IEP_PG)}}`,
    },
    ntp: {
        name: `authenticated.print.observation.${ObservationTypeUrlTags.NTPE}`,
        url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.NTPE)}}`,
    },
    ratingform: {
      name: `authenticated.print.observation.${ObservationTypeUrlTags.X82}`,
      url: `/{observationUrlTag:${generateUrlWordMatch(ObservationTypeUrlTags.X82)}}`,
  }
},
    () => import('src/app/print/print.module').then((result: { PrintModule: any }) => result.PrintModule)
);
